import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';

import ThinkingAnimationRoot from './ThinkingAnimation.style';

const ThinkingAnimation = ({ size = 'medium', color = 'primary', speed = 'normal' }) => (
  <ThinkingAnimationRoot color={color} size={size} speed={speed}>
    <Box />
    {/* <Box className="dot" />
    <Box className="dot" />
    <Box className="dot" /> */}
  </ThinkingAnimationRoot>
);

ThinkingAnimation.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['primary', 'secondary', 'gray']),
  speed: PropTypes.oneOf(['slow', 'normal', 'fast'])
};

export default ThinkingAnimation;
